import ky, { type KyInstance } from 'ky';
import { env } from '@/config/env';
import { useAuthStore } from '@/stores/auth';

export const api: KyInstance = ky.create({
  prefixUrl: env.apiBaseUrl,
  timeout: 30_000,
  retry: { limit: 1 },
  hooks: {
    beforeRequest: [
      (req) => {
        const token = useAuthStore.getState().token;
        if (token) req.headers.set('Authorization', `Bearer ${token}`);
      },
    ],
    afterResponse: [
      async (_req, _opts, res) => {
        if (res.status === 401) {
          useAuthStore.getState().logout();
        }
        return res;
      },
    ],
  },
});
